import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './consent/consent.css';
import './brand.css';

function AppReady() {
  React.useEffect(() => {
    window.requestAnimationFrame(() => {
      window.clearTimeout(window.__appBootTimeout);
      document.documentElement.classList.remove('app-booting');
      document.getElementById('app-boot-loader')?.remove();
    });
  }, []);

  return <App />;
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppReady />
  </React.StrictMode>
);
